import mapCartItem from '../shared/map-cart-item'
import buildCoupon from '../shared/build-coupon'

export default function(config, {items, discounts, total}, analytics) {
    analytics.track('begin_checkout', {
        ecommerce: {
            currency: 'USD',
            value: total,
            coupon: buildCoupon(discounts),
            items: Object.values(items).map(mapCartItem),
        },
    })
}
